module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_Data-Set-6.ee3a0b5b.png";